/* eslint-disable @typescript-eslint/no-explicit-any */
import L, { LatLngBoundsExpression } from 'leaflet';
import { Map, MapProps, Point } from 'react-leaflet';

interface CustomMapProps {
  imageCenterPaddingTopLeft?: Point;
}

const emptyBounds: LatLngBoundsExpression = [
  [0, 0, 0],
  [0, 0, 0],
];

export class MapEx<P extends MapProps = MapProps, E extends L.Map = L.Map> extends Map<P & CustomMapProps, E> {
  componentDidUpdate(prevProps: Readonly<P> & CustomMapProps, prevState: Readonly<object>): void {
    const shouldSuppressAnimation = this.shouldUpdateBounds(this.props.bounds ?? emptyBounds, prevProps.bounds ?? emptyBounds);
    super.componentDidUpdate?.(prevProps, prevState);

    if (shouldSuppressAnimation) {
      this.leafletElement.off('moveend', (this.leafletElement as any)._panInsideMaxBounds);
      this.leafletElement.panInsideBounds(this.props.maxBounds ?? emptyBounds, { animate: false });
      const options = (this as any).getFitBoundsOptions(this.props);

      this.leafletElement.fitBounds(this.props.bounds ?? emptyBounds, { ...options, paddingTopLeft: this.props.imageCenterPaddingTopLeft });
      this.leafletElement.on('moveend', (this.leafletElement as any)._panInsideMaxBounds);
    }
  }
}
